import Vue from 'vue'
import VueI18n from "vue-i18n"

Vue.use(VueI18n)

const localeList = ['ko', 'en']
const defaultLocale = 'en';

function loadLocaleMessages() {
    const locales = require.context(
        '@/locales/message',
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    )
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })

    return messages
}

function getLocale() {
    let locale = 'ko';
    if(localStorage.getItem('grm_locale')) return localStorage.getItem('grm_locale')
    if(navigator && navigator.language) {
        locale = navigator.language.substring(0, 2)
        if(!localeList.includes(locale)) locale = defaultLocale
    }
    console.log('# i18n locale:' ,locale);
    return locale;
}
function setLocale(locale){
    if (!locale) {
        locale = getLocale()
    }
    this.locale = locale;
    localStorage.setItem('grm_locale', locale);
    return this.locale;
}
export const i18n = Object.assign(new VueI18n({
    locale: getLocale(), // 기본 언어
    fallbackLocale: defaultLocale, // 기본 언어 표시에 문제가 있을 경우 대체할 언어
    messages: loadLocaleMessages(),
}), {setLocale})
